
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[prismicUid]",
      function () {
        return require("private-next-pages/[prismicUid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[prismicUid]"])
      });
    }
  